export class User {
    appName: string;
    email: string;
    firstName: string;
    lastName: string;
    ldapUid: string;
    userDisplayName: string;
    shipTos: Account[];
    activeAccount: string;



    constructor(appName?: string, email?: string, firstName?: string, lastName?: string, ldapUid?: string,
                userAcctStatCde?: number, userDisplayName?: string, shipTos?: Account[], activeAccount?: string) {
        this.appName = appName;
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.ldapUid = ldapUid;
        this.userDisplayName = userDisplayName;
        this.shipTos = shipTos;
        this.activeAccount= activeAccount;
    }
}
